module.exports = __webpack_public_path__ + "img/updating.c587179b.svg";